import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";

import CustomButton from "../../../src/components/CustomButton/CustomButton";

import { makeStyles } from "@mui/styles";

import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
// import { AiOutlineSearch } from "react-icons/ai";
// import { AiOutlineUserAdd } from "react-icons/ai";
// import { AiOutlineFileAdd } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import {
	resetCreateOrUpdateLoyaltyPoint,
	createOrUpdateLoyaltyPointReq
} from "../../redux/actions/createOrUpdateLoyaltyPointAction";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import BackButton from "../../components/BackButton/BackButton";
import Util from "../../validation";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

import { getRegenerateToken } from "../../redux/actions/regenerateTokenAction";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const AddLoyaltyService = () => {
	const [udateLoyaltyPointStatus, setudateLoyaltyPointStatus] = useState(false);
	const [operationName, setOperationName] = useState("");
	const [operationId, setoperationId] = useState("");
	const [amountCurrency, setamountCurrency] = useState("");
	const [unitAmount, setunitAmount] = useState("");
	const [loyaltyPoints, setloyaltyPoints] = useState("");
	const [amountValue, setamountValue] = useState("");
	const [minimumLoyaltyPointThreshold, setminimumLoyaltyPointThreshold] =
		useState("");
	const [currency, setCurrency] = useState("");
	const [
		createOrUpdateLoyaltyPointResArray,
		setCreateOrUpdateLoyaltyPointResArray
	] = useState("");
	const [notificationOpenSF, setNotificationOpenSF] = useState(false);

	const handleChange = ({ target: { name, value } }) => {
		if (name === "currency") {
			setCurrency(value == "Select Currency" ? "" : value);
			// setCurrency(value);
		}

		if (name === "operationName") {
			// setOperationName(value);
			setOperationName(value == "Select Operation Type" ? "" : value);
		}

		if (name === "operationId") {
			setoperationId(value);
		}

		if (name === "amountCurrency") {
			setamountCurrency(value);
		}

		// if (name === "loyaltyPoints") {
		//   setloyaltyPoints(value);
		// }

		if (name === "unitAmount") {
			// setunitAmount(value);
			Util.verifyAmount(value)
				? setunitAmount(value)
				: setunitAmount(unitAmount);
		}

		if (name === "loyaltyPoints") {
			// setloyaltyPoints(value);
			Util.verifyAmount(value)
				? setloyaltyPoints(value)
				: setloyaltyPoints(loyaltyPoints);
		}

		if (name === "amountValue") {
			// setamountValue(value);
			Util.verifyAmount(value)
				? setamountValue(value)
				: setamountValue(amountValue);
		}
		if (name === "minimumLoyaltyPointThreshold") {
			// setminimumLoyaltyPointThreshold(value);
			Util.verifyAmount(value)
				? setminimumLoyaltyPointThreshold(value)
				: setminimumLoyaltyPointThreshold(minimumLoyaltyPointThreshold);
		}
	};

	const dispatch = useDispatch();
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	// console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const adminCurrencyList = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);

	const gateLoyaltyPointOperationsListRes = useSelector(
		({ gateLoyaltyPointOperationsList }) => gateLoyaltyPointOperationsList
	);
	// console.log("gateLoyaltyPoint", gateLoyaltyPointOperationsListRes);
	// console.log("gateLoyaltyPoint", gateLoyaltyPointOperationsListRes);

	const createOrUpdateLoyaltyPointRes = useSelector(
		({ createOrUpdateLoyaltyPoint }) => createOrUpdateLoyaltyPoint
	);

	const handleNoticationCloseSF = () => {
		setNotificationOpenSF(false);
		setOperationName("Select Operation Type");
		setCurrency("Select Currency");
		setunitAmount("");
		setloyaltyPoints("");
		setamountValue("");
		setminimumLoyaltyPointThreshold("");
	};

	// console.log(createOrUpdateLoyaltyPointRes);
	// console.log("createOrUpdateLoyaltyPointRes");

	const addLoyaltyPointsListRequest = () => {
		setudateLoyaltyPointStatus(true);
		const createOrUpdateLoyaltyPointReqIs = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			settingsRequestVO: {
				action: "Add",
				// loyaltyPointId: loyaltyPointId,
				loyaltyPointId: "",
				operationId:
					operationName == "Select Operation Type" ? "" : operationName,
				amountCurrency: currency == "Select Currency" ? "" : currency,
				unitAmount: unitAmount,
				loyaltyPoints: loyaltyPoints,
				amountValue: amountValue,
				minimumLoyaltyPointThreshold: minimumLoyaltyPointThreshold
			}
			// loginDetails: {
			//   walletOwnerId: "1",
			// },
			// settingsRequestVO: {
			//   action: "Add",
			//   loyaltyPointId: "",
			//   operationId: 2,
			//   amountCurrency: "USD",
			//   unitAmount: "1",
			//   loyaltyPoints: "14",
			//   amountValue: "1",
			//   minimumLoyaltyPointThreshold: "1",
			// },
		};

		return dispatch(
			createOrUpdateLoyaltyPointReq(createOrUpdateLoyaltyPointReqIs, authToken)
		);
	};

	useEffect(() => {
		if (udateLoyaltyPointStatus) {
			if (createOrUpdateLoyaltyPointRes.data.status == "success") {
				setNotificationOpenSF(true);
				setCreateOrUpdateLoyaltyPointResArray(
					createOrUpdateLoyaltyPointRes.data
				);
			}
			if (createOrUpdateLoyaltyPointRes.data.status == "failed") {
				setNotificationOpenSF(true);
				setCreateOrUpdateLoyaltyPointResArray(
					createOrUpdateLoyaltyPointRes.data
				);
				if (
					createOrUpdateLoyaltyPointRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					createOrUpdateLoyaltyPointRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}

			if (createOrUpdateLoyaltyPointRes.data.status == "Failed") {
				setNotificationOpenSF(true);
				setCreateOrUpdateLoyaltyPointResArray(
					createOrUpdateLoyaltyPointRes.data
				);
				if (
					createOrUpdateLoyaltyPointRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					createOrUpdateLoyaltyPointRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}, [createOrUpdateLoyaltyPointRes.data.status]);

	return (
		<>
			<Layout>
				<BackButton />
				<Card>
					{/* <BackButton /> */}
					<Grid container>
						<Grid item xs={12} lg={12} md={12} sm={12}>
							<h6
								align="center"
								className="text-center themeText"
								style={{ marginTop: "1.2rem" }}
							>
								{" "}
								Add Loyalty Point
							</h6>
						</Grid>
					</Grid>
					<Grid
						container
						spacing={2}
						style={{
							padding: "25px",
							marginTop: "2rem",
							display: "flex",
							justifyContent: "center"
						}}
					>
						<Grid xs={12} item sm={12} md={8} lg={8}>
							<TextField
								select
								autoFocus
								margin="dense"
								id="name"
								label="Operation Type"
								type="name"
								fullWidth
								variant="standard"
								name="operationName"
								required
								// value={operationName || ""}
								defaultValue={"Select Operation Type" || operationName}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem
									value="Select Operation Type"
									selected="Select Operation Type"
								>
									Select Operation Type
								</MenuItem>

								{gateLoyaltyPointOperationsListRes.success &&
									[]
										.concat(
											gateLoyaltyPointOperationsListRes.data
												.actionCustomerMasterResponseVOList
										)
										.map((x) => (
											<MenuItem value={x.operationId}>
												{x.operationName}
											</MenuItem>
										))}
							</TextField>
						</Grid>

						<Grid xs={12} item sm={12} md={8} lg={8}>
							<TextField
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Currency"
								required
								fullWidth={true}
								name="currency"
								// value={currency || ""}
								defaultValue={"Select Currency" || currency}
								onChange={handleChange}
							>
								<MenuItem value="Select Currency" selected="Select Currency">
									Select Currency
								</MenuItem>
								{adminCurrencyList.success &&
									[]
										.concat(adminCurrencyList.data.currencyList)
										.map((x) => <MenuItem value={x}>{x}</MenuItem>)}
							</TextField>
						</Grid>

						<Grid xs={12} item sm={12} md={8} lg={8}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Amount Unit"
								required
								type="name"
								fullWidth
								variant="standard"
								value={unitAmount || ""}
								name="unitAmount"
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</Grid>

						<Grid xs={12} item sm={12} md={8} lg={8}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Loyalty Points"
								type="email"
								required
								fullWidth
								variant="standard"
								value={loyaltyPoints || ""}
								name="loyaltyPoints"
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</Grid>

						<Grid xs={12} item sm={12} md={8} lg={8}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Amount Value"
								required
								type="name"
								fullWidth
								variant="standard"
								value={amountValue || ""}
								name="amountValue"
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</Grid>

						<Grid xs={12} item sm={12} md={8} lg={8}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Minimum Threshold"
								required
								type="name"
								fullWidth
								variant="standard"
								value={minimumLoyaltyPointThreshold}
								name="minimumLoyaltyPointThreshold"
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</Grid>
					</Grid>

					<Grid
						container
						style={{
							padding: "10px",
							marginTop: "1.5rem",
							marginBottom: "15px",
							display: "flex",
							justifyContent: "center"
						}}
					>
						{/* <Button
              style={{
                backgroundColor: "#00b9f5",
                color: "white",
              }}
              variant="contained"
              onClick={addLoyaltyPointsListRequest}
              endIcon={<AddCircleOutlineIcon />}
            >
              Add
            </Button> */}
						<CustomButton
							style={{
								padding: "8px"
							}}
							onClick={addLoyaltyPointsListRequest}
						>
							Add <AddCircleOutlineIcon />
						</CustomButton>
					</Grid>
				</Card>

				{createOrUpdateLoyaltyPointResArray.status == "failed" && (
					<div>
						<Dialog open={notificationOpenSF} onClose={handleNoticationCloseSF}>
							<DialogContent
								className="text-center"
								style={{ backgroundColor: "#00b9f51c" }}
							>
								<img src={failed} alt="" width="100px" className="my-2" />
							</DialogContent>
							<DialogContent>
								<h3
									style={{ margin: "0", fontSize: "15px", textAlign: "center" }}
								>
									Update Record Failed{" "}
								</h3>
							</DialogContent>
							<DialogActions style={{ justifyContent: "center" }}>
								{/* <Button
									style={{
										margin: "10px 0",
										backgroundColor: "#00b9f5",
										color: "white"
									}}
									variant="contained"
									onClick={handleNoticationCloseSF}
								>
									Ok
								</Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={handleNoticationCloseSF}
								>
									Ok
								</CustomButton>
							</DialogActions>
						</Dialog>
					</div>
				)}

				{createOrUpdateLoyaltyPointResArray.status == "Failed" && (
					<div>
						<Dialog open={notificationOpenSF} onClose={handleNoticationCloseSF}>
							<DialogContent
								className="text-center"
								style={{ backgroundColor: "#00b9f51c" }}
							>
								<img src={failed} alt="" width="100px" className="my-2" />
							</DialogContent>
							<DialogContent>
								<h3
									style={{ margin: "0", fontSize: "15px", textAlign: "center" }}
								>
									{createOrUpdateLoyaltyPointResArray.description}
								</h3>
							</DialogContent>
							<DialogActions style={{ justifyContent: "center" }}>
								{/* <Button
									style={{
										margin: "10px 0",
										backgroundColor: "#00b9f5",
										color: "white"
									}}
									variant="contained"
									onClick={handleNoticationCloseSF}
								>
									Ok
								</Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={handleNoticationCloseSF}
								>
									Ok
								</CustomButton>
							</DialogActions>
						</Dialog>
					</div>
				)}

				{createOrUpdateLoyaltyPointResArray.status == "success" && (
					<div>
						<Dialog open={notificationOpenSF} onClose={handleNoticationCloseSF}>
							<DialogContent
								className="text-center"
								style={{ backgroundColor: "#00b9f51c" }}
							>
								<img src={success} alt="" width="100px" className="my-2" />
							</DialogContent>
							<DialogContent>
								<h3
									style={{ margin: "0", fontSize: "15px", textAlign: "center" }}
								>
									{createOrUpdateLoyaltyPointResArray.description}
								</h3>
							</DialogContent>
							<DialogActions style={{ justifyContent: "center" }}>
								{/* <Button
									style={{
										margin: "10px 0",
										backgroundColor: "#00b9f5",
										color: "white"
									}}
									variant="contained"
									onClick={handleNoticationCloseSF}
								>
									Ok
								</Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={handleNoticationCloseSF}
								>
									Ok
								</CustomButton>
							</DialogActions>
						</Dialog>
					</div>
				)}
			</Layout>
		</>
	);
};

export default AddLoyaltyService;
